import React, {
    Component
} from 'react';
import activePage from './manageContent';
import SnackbarCustom from '../custom/snackbar/SnackbarCustom';
import snackbarContentCustomTypes from '../custom/snackbar/SnackbarContentCustomTypes';
import BottomNavigationCustom from '../custom/bottomNavigation/BottomNavigation';
import "./Content.css";
import {
    Route, withRouter
} from "react-router-dom";
import FilAriane from '../custom/filAriane/FilAriane';

class Content extends Component {
    constructor(props) {
        super(props);
        this.clickChildHandle = null;
        this.currentContent = null;
        this.snackBarRef = {};
    }

    loadBottomNavigation() {
        var retour = (<div />);
        if (this.currentContent.showBottomNavigation) {
            retour = (
                <BottomNavigationCustom snackBarRef={this.snackBarRef} currentContent={this.currentContent} />
            );
        }
        return retour;
    }

    render() {
        this.currentContent = activePage();
        return (
            <div id="content">
                <FilAriane pages={this.currentContent.visiblePath.split("/")} />
                <div id="innerContent">
                    <Route key={this.currentContent.path} exact={this.currentContent.exact} path={this.currentContent.visiblePath} render={() => this.currentContent.page} />
                </div>
                <div className="bottomBar">
                    <SnackbarCustom type={snackbarContentCustomTypes.success.value} open={false} ref={instance => { this.snackBarRef["instance"] = instance; }} />
                    {this.loadBottomNavigation()}
                </div>
            </div>
        );
    }
}

export default withRouter(Content);


// WEBPACK FOOTER //
// ./src/components/content/Content.js